import { BillIcon, CashIcon, PettyCashBudgetIcon } from '@razorpay/blade/components';
import React from 'react';
import { CtcBreakdownData } from '../types';
import ComponentContainer from './generics/ComponentContainer';
import ComponentHeader from './generics/ComponentHeader';
import ComponentSection from './generics/ComponentSection';
import ComponentSectionItem from './generics/ComponentSectionItem';
import ComponentTable from './generics/CtcBreakdownTable';
import { usePayDetails } from '../context/PayDetailsContext';

const CtcComponent = () => {
  const { compensationData } = usePayDetails();
  const ctcData: CtcBreakdownData = compensationData.ctcBreakdownData;

  return (
    <ComponentContainer>
      {ctcData.fixed.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<CashIcon size="medium" color="surface.icon.onSea.onSubtle" />}
            iconBackground={'surface.background.sea.subtle'}
            title={'Fixed'}
            description={'Monthly earning component'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.fixed} hideZeroAmountComponents={true} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.variable.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<PettyCashBudgetIcon size="medium" color="surface.icon.primary.normal" />}
            iconBackground={'surface.background.primary.subtle'}
            title={'Variable'}
            description={'Variable component based on performance, not part of monthly salary'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.variable} showMonthlyColumn={false} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.otherCtc.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<BillIcon size="medium" color="surface.icon.gray.normal" />}
            iconBackground={'surface.background.gray.intense'}
            title={'Other CTC component'}
            description={'Components part of CTC but not directly payable to the employee'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.otherCtc} showMonthlyColumn={false} />
          </ComponentSectionItem>
        </ComponentSection>
      )}
    </ComponentContainer>
  );
};

export default CtcComponent;
